/**
 * See https://www.w3.org/TR/css-counter-styles-3/#counter-style-suffix
 *
 * @remarks We are using non-breaking space, otherwise iOS text elements get trimmed.
 */
export const DEFAULT_SUFFIX = '\u002E\u00A0';
export const CJK_SUFFIX = '\u3001';
